export default __webpack_public_path__ + "static/media/HASSAN_FR_EPILOG2.623b134b.mp3";